import axios from "axios";
import moment from "moment-timezone";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalQuestion from "../../components/blocks/ModalQuestion";
import ModalSimple from "../../components/blocks/ModalSimple";
import ModalTarifChange from "../../components/blocks/ModalTarifChange";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { Button } from "../../components/controls/Button/Button";
import FaqQuestion from "../../components/faq/FaqQuestion";
import ChackedIcon from "../../components/icons/ChackedIcon";
import {
    OnestNormalSmall,
    OnestSemiBoldMed
} from "../../components/styled/TextComponents";
import { PageTitle } from "../../components/text/PageTitle";
import Config from "../../Config";
import {
    color_black_ultra_light,
    color_green_pastel,
    color_green_pastel_light,
    color_grey_dark,
    color_red_default,
    color_red_default_t20,
    color_red_warning,
    color_red_warning_t10,
    color_white
} from "../../constants/colors";
import { useWindowDimensions } from "../../utils";
import PersonalDefaultPage from "./PersonalDefaultPage";

import OptionTile from "../../components/blocks/BillingPage/OptionTile";
import ModalHowReferalWorks from "../../components/blocks/referral/ModalHowReferalWorks";
import ModalQuestionTwoAnswers from "../../components/blocks/ModalQuestionTwoAnswers";
import ModalWaiting from "../../components/blocks/ModalWaiting";
import AlertIcon from "../../components/icons/AlertIcon";
import { setUser } from "../../store/UserSlice";
import { isDesktop } from "../../utilities/getDeviceType";
import { useI18n } from "../../i18n/I18nProvider";

export const BillingPage = () => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const dispatch = useDispatch();
    const userData = useSelector(state => state.user);
    const navigate = useNavigate();
    const [isOpenTarifModal, setIsOpenTarifModal] = React.useState(false);
    const [isOpenRecurentModal, setIsOpenRecurentModal] = React.useState(false);
    const [isOpenSimpleModal, setIsOpenSimpleModal] = React.useState(false);
    const [isOpenHowReferalWorksModal, setIsOpenHowReferalWorksModal] = React.useState(false);
    const [modalSimpeObj, setModalSimpeObj] = React.useState({ type: "success", h2: "", p: "", buttonText: t("Понятно") });
    const [isOpenWaitingModal, setIsOpenWaitingModal] = React.useState(false);
    const [modalWaitingObj, setModalWaitingObj] = React.useState({ type: "info", h2: t("Загрузка..."), p: t("Пожалуйста, подождите"), buttonText: t("Закрыть") });

    const [countOfUnsuccessfulPayments, setCountOfUnsuccessfulPayments] = React.useState(0);
    const [isShowModalUnsuccessfulPayments, setIsShowModalUnsuccessfulPayments] = React.useState(false);
    const [billingStatus, setBillingStatus] = React.useState(null); // paid, trial, unpaid, noReBill

    ///for tests
    /*
        const [countOfUnsuccessfulPayments, setCountOfUnsuccessfulPayments] = React.useState(2);
        const [isShowModalUnsuccessfulPayments, setIsShowModalUnsuccessfulPayments] = React.useState(true);
        const [billingStatus, setBillingStatus] = React.useState("unpaid"); // paid, trial, unpaid, noReBill
    */
    const [faqData, setFaqData] = React.useState([{
        id: 0,
        question: "Что произойдёт, когда закончится пробный период?",
        answer: "С привязанной карты автоматически спишется сумма выбранного тарифа. Если вы отменили автопродление - списание не произойдёт и доступ будет приостановлен.",
        active: true,
    },
    {
        id: 1,
        question: "Как отключить автопродление?",
        answer: "Нажмите «Отменить подписку». Платформа останется доступной до конца оплаченного периода, затем доступ приостановится.",
        active: false,
    },
    {
        id: 2,
        question: "Я хочу перейти на другой тариф. Деньги спишутся сразу?",
        answer: "Нет. Новый тариф активируется после окончания текущего оплаченного периода. Списание произойдёт в момент перехода.",
        active: false,
    },
    {
        id: 3,
        question: "У меня не прошла оплата. Что делать?",
        answer: "Проверьте баланс карты и при необходимости обновите её данные через кнопку «Обновить карту».",
        active: false,
    },
    {
        id: 4,
        question: "Я оплатил, но подписка не активировалась. Почему?",
        answer: "Иногда активация может занять до 5 минут. Попробуйте обновить страницу. Если ничего не изменилось - напишите в поддержку.",
        active: false,
    },
    {
        id: 5,
        question: "У меня завис урок или перестал работать один из слайдов. Что делать?",
        answer: "Просто обновите страницу, урок должен открыться в том месте, где вы остановились. Если не помогло - очистите кеш в браузере или попробуйте другой браузер (лучше всего работает в Chrome, мы рекомендуем использовать именно его).",
        active: false,
    },
    {
        id: 6,
        question: "Если я отменю подписку, мои данные сохранятся?",
        answer: "Да. Все ученики, расписание и программа сохраняются до конца оплаченного периода. После приостановки доступ к ним временно блокируется, но данные не удаляются.",
        active: false,
    }]);

    const getUser = useCallback(async () => {
        try {
            const data = await get_user();
            dispatch(setUser(data));
            if (!data.paid_until || !data.tariff) { navigate("/auth/tariffs"); }
            if (data) {
                if (
                    moment.utc(data?.paid_until)
                        .tz(data?.time_zone || "Europe/Moscow")
                        .isBefore(moment().tz(data?.time_zone || "Europe/Moscow"))
                ) {

                    try {
                        if (data.rebillid) {
                            let backendAddr = Config.BACKEND_ADDR + "/payments/getPaymentsCount";
                            try {
                                const paymentsResponse = await axios.get(backendAddr);
                                if (paymentsResponse.status === 200) {
                                    if (paymentsResponse.data.payments_count) {
                                        setCountOfUnsuccessfulPayments(+paymentsResponse.data.payments_count);
                                        setIsShowModalUnsuccessfulPayments(true);
                                    }
                                }
                            } catch (err) {
                                console.error("Ошибка чтения количесва неуспешных транзакций в БД!");
                            }
                        }

                    } catch (err) {
                        console.error("Ошибка чтения количесва пер в БД!");
                    } finally {
                        setBillingStatus("unpaid");
                    }
                } else {
                    if (data.rebillid) {
                        //setBillingStatus("paid");
                        let backendAddr = Config.BACKEND_ADDR + "/payments/isFirstTrial";
                        const trialResponse = await axios.get(backendAddr);
                        if (trialResponse.status === 200) {
                            if (trialResponse.data === true) {
                                setBillingStatus("trial");
                            } else {
                                setBillingStatus("paid");
                            }
                        }
                    } else {
                        setBillingStatus("noReBill");
                    }

                }

            }
        } catch (error) {
            console.error("Ошибка при получении пользователя:", error);
        }
    }, [dispatch, navigate]);

    useEffect(() => {
        getUser();
        const interval = setInterval(() => {
            getUser();
        }, 300000);

        return () => clearInterval(interval);

    }, [getUser])

    const onChangeFaqQuestionClickButton = (question) => {
        setFaqData(prevData => prevData.map(el => {
            if (el.id === question.id) {
                return { ...el, active: !el.active };
            }
            return el;
        }));
    }

    const handleChangeTarif = () => {
        const newTarif = userData.tariff === "m" ? "y" : "m";

        // Обновляем тариф через API
        axios.post(Config.BACKEND_ADDR + "/auth/user/tariff", { tariff: newTarif })
            .then(response => {
                // handle success if needed
                getUser(); // Обновляем данные пользователя после изменения тарифа     
                setIsOpenTarifModal(false);
            })
            .catch(error => {
                // handle error if needed
                alert(t("Ошибка при изменении тарифа:"));
            });
        // handle success if needed

    }

    const handleCancelSubscription = () => {
        setIsOpenRecurentModal(false);

        // Отправляем запрос на отмену подписки через API
        axios.post(Config.BACKEND_ADDR + "/auth/user/rebillid", { rebillid: "", pan: "", card_id: null, exp_date: "" })
            .then(response => {
                if (response.status === 200) {
                    // Обновляем данные пользователя после отмены подписки
                    getUser();
                    setIsOpenSimpleModal(true);
                    setModalSimpeObj({
                        type: "success",
                        h2: t("Подписка отменена"),
                        p: t("Вы можете пользоваться платформой до окончания оплаченного или пробного периода. Автосписание отключено"),
                        buttonText: t("Понятно")
                    });
                }
            })
            .catch(error => {
                console.error("Ошибка при отмене подписки:", error);
                alert(t("Ошибка при отмене подписки. Пожалуйста, попробуйте позже."));
            });
    }

    const HandleReRecurrent = () => {
        // Отправляем запрос на повторное подключение автоплатежа
        let backendAddr = Config.BACKEND_ADDR + "/payments/reRecurrent/" + userData.tariff; // /api
        axios.get(backendAddr).then(response => {
            if (response.status === 200) {
                if (response?.data?.PaymentURL) {
                    // открываем попап с формой оплаты
                    window.location.href = response?.data?.PaymentURL;
                }
            }
        }).catch(err => {
            alert(t("Ошибка при повторном подключении автоплатежа."))
        })
    }

    const handleManualPayment = () => {
        // Здесь можно добавить логику для повторной попытки платежа
        let backendAddr = Config.BACKEND_ADDR + "/payments/manualRecurrent"
        setIsShowModalUnsuccessfulPayments(false);
        setModalWaitingObj({ type: "info", h2: t("Пожалуйста, подождите"), p: t("Ожидаем ответ от банка об успешном списании средств...") });
        setIsOpenWaitingModal(true);
        axios.post(backendAddr).then(response => {
            if (response.status === 200) {
                const checkWebhookReview = setInterval(async () => {
                    try {
                        const reviewResponse = await axios.get(Config.BACKEND_ADDR + "/payments/webhook_review/" + response?.data?.payment_id);
                        if (
                            Array.isArray(reviewResponse.data) &&
                            reviewResponse.data.length > 0
                        ) {
                            reviewResponse.data.map((el, index) => {
                                console.log(el)
                                //if((response?.data?.payment_id && el.payment_id !== response?.data?.payment_id) || response?.data?.payment_id === undefined){
                                if (el.status === "CONFIRMED") {

                                    clearInterval(checkWebhookReview);
                                    setIsOpenWaitingModal(false);
                                    setModalSimpeObj({
                                        type: "success",
                                        h2: t("Оплата прошла успешно!"),
                                        p: t("Теперь вы можете продолжить пользоваться платформой без ограничений."),
                                        buttonText: t("Закрыть")
                                    });
                                    setIsOpenSimpleModal(true);
                                    getUser();
                                } else if (el.status === "REJECTED") {
                                    clearInterval(checkWebhookReview);
                                    setIsOpenWaitingModal(false);
                                    setModalSimpeObj({
                                        type: "alert",
                                        h2: t("Оплата не прошла"),
                                        p: t("Попробуйте еще раз или обновите карту."),
                                        buttonText: t("Закрыть")
                                    });
                                    setIsOpenSimpleModal(true);
                                }
                                //}
                            });
                        }
                    } catch (err) {
                        // Можно обработать ошибку, если нужно
                    }
                }, 5000);
            } else if (response.status === 409) {
                setIsOpenWaitingModal(false);
                setModalSimpeObj({
                    type: "success",
                    h2: t("У Вас уже оплачена подписка!"),
                    p: t("Теперь вы можете продолжить пользоваться платформой без ограничений."),
                    buttonText: t("Хорошо")
                });
                setIsOpenSimpleModal(true);
                getUser();

            } else {
                setIsOpenWaitingModal(false);
                setModalSimpeObj({
                    type: "alert",
                    h2: t("Оплата не прошла"),
                    p: t("Попробуйте еще раз или обновите карту."),
                    buttonText: t("Закрыть")
                });
                setIsOpenSimpleModal(true);
            }
        }).catch(err => {
            getUser();
            console.warn(err)
        })
        console.log("Повторная попытка платежа");
    }

    const getLayoutWidth = () => {
        return (screenWidth > 1420 ?
            screenWidth - 340
            :
            (screenWidth > 650 ?
                (
                    screenWidth >= 1280 && isDesktop() ?
                        screenWidth - 304
                        :
                        screenWidth - 150
                )
                :
                screenWidth - 50
            )
        );
    }

    return (
        <PersonalDefaultPage>
            <ModalTarifChange
                isOpen={isOpenTarifModal}
                onClose={() => setIsOpenTarifModal(false)}
                currentTarif={userData.tariff}
                setNewTarif={handleChangeTarif}
            />
            <ModalQuestion
                type="alert"
                h2={t("Вы отменяете подписку и автосписание")}
                p={t("Она будет активна до конца пробного периода, после чего списание не произойдет")}
                isOpen={isOpenRecurentModal}
                onClose={(answer) => {
                    if (answer) {
                        handleCancelSubscription();
                    }
                    setIsOpenRecurentModal(false)
                }}
                yesText={t("Подтвердить")}
                noText={t("Отмена")}
                isButtonRevers={true}
            />
            <ModalQuestionTwoAnswers
                type="alert"
                h2={t("Не удалось списать оплату")}
                p={`${t("Мы попробуем списать ещё ")}${countOfUnsuccessfulPayments === 1 ? t("два раза - через 24 и 48 часов") : t("через 24 часа")}${t(". Или обновите карту - доступ восстановится сразу")}`}
                isOpen={countOfUnsuccessfulPayments > 0 && isShowModalUnsuccessfulPayments && billingStatus === "unpaid"}
                onClose={() => setIsShowModalUnsuccessfulPayments(false)}
                onAnswer={(answer) => {
                    if (answer) {
                        // Здесь можно добавить логику для повторной попытки платежа
                        handleManualPayment();
                    } else {
                        // Здесь можно добавить логику для обновления карты
                        // Например, перенаправить пользователя на страницу обновления карты
                        let backendAddr = Config.BACKEND_ADDR + "/payments/reRecurrent/" + userData.tariff // /api
                        axios.get(backendAddr).then(response => {
                            if (response.status === 200) {
                                if (response?.data?.PaymentURL) {
                                    // открываем попап с формой оплаты
                                    window.location.href = response?.data?.PaymentURL;
                                }
                            }
                        }).catch(err => {
                            alert(err?.message || String(err))
                        })
                    }
                    setCountOfUnsuccessfulPayments(0);
                }}
                yesText={t("Повторить попытку")}
                noText={t("Обновить карту")}
            />
            <ModalSimple
                isOpen={isOpenSimpleModal}
                onClose={() => setIsOpenSimpleModal(false)}
                type={modalSimpeObj.type}
                h2={modalSimpeObj.h2}
                p={modalSimpeObj.p}
                buttonText={modalSimpeObj.buttonText}
            />
            <ModalHowReferalWorks
                isOpen={isOpenHowReferalWorksModal}
                onClose={() => setIsOpenHowReferalWorksModal(false)}
                referal_code={userData.referal_code}
            />
            <ModalWaiting
                isOpen={isOpenWaitingModal}
                onClose={() => setIsOpenWaitingModal(false)}
                type={modalWaitingObj.type}
                h2={modalWaitingObj.h2}
                p={modalWaitingObj.p}
            />
            <div>
                <PageTitle style={{ marginBottom: 6, width: screenWidth - 198 }} title={t("Управление подпиской")} />
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    //backgroundColor: color_grey_ultra_light,
                    //padding: screenWidth > 650 ? 50 : 0,
                    padding: 0,
                    gap: 18,
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "flex-start",
                    flexWrap: "wrap",
                    width: getLayoutWidth(),
                    marginBottom: 40,
                }}>
                    <div style={{
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        padding: 24,
                        //width: screenWidth > 1420 ? screenWidth - 388 : (screenWidth > 650 ? screenWidth - 198 : screenWidth - 98),
                        //width: screenWidth > 1420 ? screenWidth - 378 : (screenWidth > 990 ? screenWidth - 150 : screenWidth - 98),
                        width: getLayoutWidth() - 48,
                        gap: 10,
                        backgroundColor: color_white,
                        borderRadius: 16,
                    }}>
                        {billingStatus ?
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    height: 20,
                                    position: screenWidth > 800 ? "absolute" : "relative",
                                    top: screenWidth > 800 ? 20 : 0,
                                    right: screenWidth > 800 ? 24 : 0,
                                    backgroundColor: ((billingStatus === "paid" || billingStatus === "trial") && userData.rebillid) ? color_green_pastel_light : color_red_warning_t10,
                                    padding: 8,
                                    paddingLeft: 10,
                                    paddingRight: 12,
                                    borderRadius: 16,
                                }}
                            >
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 20,
                                    minWidth: 20,
                                    height: 20,
                                    backgroundColor: ((billingStatus === "paid" || billingStatus === "trial") && userData.rebillid) ? color_green_pastel : color_red_warning,
                                    borderRadius: "50%",
                                    marginRight: 8,
                                }}>
                                    {(billingStatus === "paid" || billingStatus === "trial") && userData.rebillid ?
                                        <ChackedIcon width={16} height={16} />
                                        :
                                        <AlertIcon width={16} height={16} />
                                    }
                                </div>
                                {billingStatus === "trial"
                                    ?
                                    userData.rebillid
                                        ?
                                        <OnestNormalSmall style={{ color: color_green_pastel }}>
                                            {/*писать  пробный период только когда он реально пробный */}
                                            {t("Пробный период до ")}{moment.utc(userData.paid_until).tz(userData.time_zone || "Europe/Moscow").format('DD.MM.YYYY')}
                                        </OnestNormalSmall>
                                        :
                                        <OnestNormalSmall style={{ color: color_red_warning }}>
                                            {t("Пробный период закончится ")}{moment.utc(userData.paid_until).tz(userData.time_zone || "Europe/Moscow").format('DD.MM.YYYY')}
                                        </OnestNormalSmall>
                                    : null
                                }
                                {billingStatus === "paid" && userData.rebillid
                                    ?
                                    <OnestNormalSmall style={{ color: color_green_pastel }}>
                                        {t("Активна до ")}{moment.utc(userData.paid_until).tz(userData.time_zone || "Europe/Moscow").format('DD.MM.YYYY')}
                                    </OnestNormalSmall>
                                    : null
                                }

                                {billingStatus === "unpaid"
                                    ?
                                    (countOfUnsuccessfulPayments > 0 ?
                                        <OnestNormalSmall style={{ color: color_red_warning }}>
                                            {t("Ошибка оплаты")}
                                        </OnestNormalSmall>
                                        :
                                        <OnestNormalSmall style={{ color: color_red_warning }}>
                                            {t("Завершена ")}{moment.utc(userData.paid_until).tz(userData.time_zone || "Europe/Moscow").format('DD.MM.YYYY')}
                                        </OnestNormalSmall>
                                    )
                                    :
                                    null
                                }
                                {billingStatus === "noReBill"
                                    ?
                                    <OnestNormalSmall style={{ color: color_red_warning }}>
                                        {t("Завершится ")}{moment.utc(userData.paid_until).tz(userData.time_zone || "Europe/Moscow").format('DD.MM.YYYY')}
                                    </OnestNormalSmall>
                                    : null
                                }

                            </div>

                            : null
                        }
                        <OnestSemiBoldMed style={{ marginBottom: 0 }} >
                            {t("Ваш тариф: ")}{userData.tariff === "m" ? t("Месячный") : t("Годовой")} {t("план")}
                        </OnestSemiBoldMed>
                        {(billingStatus === "trial" && userData.rebillid) || (billingStatus === "paid" && userData.rebillid) ?
                            <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                {userData.tariff === "m" ? "1500" : "12000"} ₽ {t("спишется автоматически ")}{moment.utc(userData.paid_until).tz(userData.time_zone || "Europe/Moscow").format('DD.MM.YYYY')} {userData.pan && <span>{t("c карты ")}{userData.pan.slice(-4)}</span>}
                            </OnestNormalSmall>
                            :
                            (billingStatus === 'trial'
                                ?
                                <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                    {t("Автописание отключено. Вы можете использовать платформу до окончания ")}<br />{t("бесплатного пробного периода, после доступ будет заблокирован.")}
                                </OnestNormalSmall>
                                : (billingStatus === 'paid' ?
                                    <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                        {t("Автописание отключено. Вы можете использовать платформу до окончания ")}<br />{t("оплаченного периода, после доступ будет заблокирован.")}
                                    </OnestNormalSmall>
                                    : (billingStatus === 'unpaid' ?
                                        (countOfUnsuccessfulPayments > 0 ?
                                            <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                                {t("Не удалось списать оплату.")}
                                                {/*Было совершено {countOfUnsuccessfulPayments} попыт{getRussianNumberEndingFemaleGenetive(countOfUnsuccessfulPayments)} списания.  */}
                                                <br /> {t("Пожалуйста, обновите карту или пополните счёт.")}
                                            </OnestNormalSmall>
                                            : (userData.rebillid ?
                                                <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                                    {t("В ожидании автоплатежа")}{userData.pan && <span> {t("c карты ")}{userData.pan.slice(-4)}</span>}. <br /> {t("Доступ заблокирован.")}
                                                </OnestNormalSmall>
                                                :
                                                <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                                    {t("Автописание отключено.")}  <br /> {t("Доступ заблокирован.")}
                                                </OnestNormalSmall>
                                            )
                                        )
                                        : (billingStatus === 'noReBill' ?
                                            <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                                                {t("Автописание отключено. Вы можете использовать платформу до окончания ")}<br />{t("оплаченного периода, после доступ будет заблокирован.")}
                                            </OnestNormalSmall>
                                            : null
                                        )
                                    )
                                )
                            )
                        }
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: 16,
                            flexWrap: "wrap",
                            width: screenWidth > 1420 ? screenWidth - 456 : (screenWidth > 650 ? screenWidth - 264 : screenWidth - 98),
                            marginTop: 16,
                        }}>
                            {
                                countOfUnsuccessfulPayments > 0 && billingStatus === "unpaid" ?
                                    <Button
                                        onClick={() => {
                                            handleManualPayment();
                                        }}
                                        color={color_red_default}
                                        backgroundColor={color_red_default_t20}
                                        style={{
                                            width: 192,
                                            height: 40,
                                            padding: 8,
                                            borderRadius: 15,
                                            border: "none",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            //marginTop: screenWidth > 800 ? 0 : 16,
                                            //marginBottom: screenWidth > 800 ? 0 : 16,
                                            color: color_red_default,
                                            borderColor: color_red_default_t20,
                                            backgroundColor: color_red_default_t20,
                                        }}
                                    >
                                        {t("Повторить попытку")}
                                    </Button>
                                    : null
                            }
                            <Button
                                onClick={() => {
                                    if (userData.rebillid && userData.tariff) {
                                        setIsOpenRecurentModal(true)
                                    } else {
                                        HandleReRecurrent()
                                    }
                                }}
                                color={color_red_default}
                                backgroundColor={color_red_default_t20}
                                style={{
                                    //width: 192,
                                    height: 40,
                                    padding: 8,
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                    borderRadius: 15,
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    //marginTop: screenWidth > 800 ? 0 : 16,
                                    //marginBottom: screenWidth > 800 ? 0 : 16,
                                    color: countOfUnsuccessfulPayments > 0 && billingStatus === "unpaid" ? color_black_ultra_light : color_red_default,
                                    borderWidth: countOfUnsuccessfulPayments > 0 && billingStatus === "unpaid" ? "1px" : "0",
                                    borderStyle: countOfUnsuccessfulPayments > 0 && billingStatus === "unpaid" ? "solid" : "none",
                                    borderColor: countOfUnsuccessfulPayments > 0 && billingStatus === "unpaid" ? color_grey_dark : color_red_default_t20,
                                    backgroundColor: countOfUnsuccessfulPayments > 0 && billingStatus === "unpaid" ? color_white : color_red_default_t20,
                                }}
                            >
                                {
                                    userData.rebillid && userData.tariff ?
                                        t("Отменить подписку")
                                        :
                                        t("Возобновить подписку")
                                }
                            </Button>
                        </div>
                    </div>

                    <OptionTile
                        imgName="redRenewArrow"
                        titleText={t("Изменение тарифа")}
                        text={t("Если хотите перейти на другой тариф")}
                        buttonText={t("Изменить тариф")}
                        buttonOnClick={() => setIsOpenTarifModal(true)}
                        baseWidth={getLayoutWidth()}
                    />
                    <OptionTile
                        imgName="redWallet"
                        titleText={t("Обновление карты")}
                        text={t("Если данные карты изменились или оплата не прошла")}
                        buttonText={t("Обновить карту")}
                        buttonOnClick={() => {
                            let backendAddr = Config.BACKEND_ADDR + "/payments/reRecurrent/" + userData.tariff // /api
                            axios.get(backendAddr).then(response => {
                                if (response.status === 200) {
                                    if (response?.data?.PaymentURL) {
                                        // открываем попап с формой оплаты
                                        window.location.href = response?.data?.PaymentURL;
                                    }
                                }
                            }).catch(err => {
                                alert(err)
                            })
                        }}

                        baseWidth={getLayoutWidth()}
                    />
                    <OptionTile
                        imgName="redReferals"
                        titleText={t("Реферальная программа")}
                        text={t("Поделитесь кодом ") + userData.referal_code + t(" — коллега вводит его при регистрации, бонус приходит после первой оплаты")}
                        buttonText={t("Подробнее")}
                        buttonOnClick={() => setIsOpenHowReferalWorksModal(true)}

                        baseWidth={getLayoutWidth()}
                    />

                </div>
                <PageTitle title={t("Частые вопросы")} />
                <div style={{
                    width: getLayoutWidth(),
                    borderRadius: 20,
                    padding: 25,
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    gap: 30,
                    backgroundColor: color_white,
                }}>
                    {faqData.map(el =>
                        <FaqQuestion
                            key={el.id}
                            question={{ ...el, question: t(el.question), answer: t(el.answer) }}
                            onChangeFaqQuestionClickButton={onChangeFaqQuestionClickButton} />
                    )}
                </div>
            </div>
        </PersonalDefaultPage>
    )
}
